import { acceptHMRUpdate, defineStore } from 'pinia'

export const useCartStore = defineStore({
    id: 'cart',
    state: () => {
        return {
            cartItems: []
        }
    },
    getters: {
        getCartTotal (state) {
            return state.cartItems.map(it => it.quantity * parseFloat(it.price)).reduce((a, b) => a + b, 0)
        },
    },
    actions: {
        cartSetAmount(payload) {
            const cartItem = this.cartItems.find((i) => i.id === payload.item.id);
            if (!cartItem) {
                this.cartItems.push({
                    ...payload.item,
                    quantity: payload.amount,
                });
            } else {
                cartItem.quantity = payload.amount;

                if (cartItem.quantity === 0) {
                    this.cartItems = this.cartItems.filter((i) => i.id !== payload.item.id)
                }
            }
        }
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCartStore, import.meta.hot))
}